import { MapPin, Phone, MessageCircle, Clock } from "lucide-react";
import { ADDRESS, MAPS_EMBED, PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "./data";

export const Contact = () => (
    <section id="contact" data-testid="contact-section" className="bg-[#FAF5EF] py-24">
        <div className="mx-auto max-w-6xl px-5">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#D4AF37]">Visit or Call</p>
            <h2 className="mt-3 font-serif text-4xl tracking-tight text-[#2C2A29] sm:text-5xl">
                Makeup artist in Thiruninravur, Chennai
            </h2>
            <div className="mt-14 grid gap-8 md:grid-cols-2">
                <div className="rounded-sm border border-[#D4AF37]/20 bg-white p-8 sm:p-10">
                    <div className="flex gap-4">
                        <MapPin className="mt-1 h-6 w-6 shrink-0 text-[#D4AF37]" />
                        <div>
                            <h3 className="font-serif text-2xl font-medium text-[#2C2A29]">
                                Monisha Makeover Artistry
                            </h3>
                            <p data-testid="contact-address" className="mt-2 text-sm leading-relaxed text-[#5A5652]">
                                {ADDRESS}
                            </p>
                        </div>
                    </div>
                    <div className="mt-6 flex gap-4">
                        <Clock className="mt-1 h-6 w-6 shrink-0 text-[#D4AF37]" />
                        <p className="text-sm leading-relaxed text-[#5A5652]">
                            Open all days · 6:00 AM – 9:00 PM
                            <br />
                            Home service available across Chennai
                        </p>
                    </div>
                    <div className="mt-8 flex flex-col gap-4 sm:flex-row">
                        <a
                            href={PHONE_TEL}
                            data-testid="contact-call-link"
                            className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-[#D4AF37] px-6 py-3.5 text-sm font-extrabold text-[#2C2A29] shadow-md transition-transform duration-200 hover:-translate-y-1"
                        >
                            <Phone className="h-4 w-4" />
                            {PHONE_DISPLAY}
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="contact-whatsapp-button"
                            className="inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-[#25D366] px-6 py-3.5 text-sm font-extrabold text-white shadow-md transition-transform duration-200 hover:-translate-y-1"
                        >
                            <MessageCircle className="h-4 w-4" />
                            WhatsApp Us
                        </a>
                    </div>
                </div>
                <div className="overflow-hidden rounded-sm border border-[#D4AF37]/20">
                    <iframe
                        title="Monisha Makeover Artistry location on Google Maps"
                        data-testid="maps-embed"
                        src={MAPS_EMBED}
                        className="h-full min-h-[320px] w-full"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    </section>
);
